import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="w-full bg-black text-white py-8 mt-auto">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
                    <div>
                        <h3 className="text-xl font-bold mb-4">Kodu Tara</h3>
                        <p className="text-gray-400 text-sm">
                            Aracınız ve işletmeniz için modern ulaşılabilirlik çözümü.
                            QR kodunuzu yapıştırın, her zaman ulaşılabilir olun.
                        </p>
                    </div>
                    <div>
                        <h4 className="text-lg font-bold mb-4">Hızlı Bağlantılar</h4>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li><Link to="/about" className="hover:text-white transition-colors">Hakkımızda</Link></li>
                            <li><Link to="/contact" className="hover:text-white transition-colors">İletişim</Link></li>
                            <li><Link to="/privacy-kvkk" className="hover:text-white transition-colors">Gizlilik ve KVKK</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-lg font-bold mb-4">İletişim</h4>
                        <p className="text-gray-400 text-sm">info@kodutara.com</p>
                    </div>
                </div>
                <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
                    <p>© {new Date().getFullYear()} Kodu Tara. Tüm hakları saklıdır.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;